import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TdspContextualCategoryService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/custom-contextual-categories/`;

  getLanguages(params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}contextual-languages`,
      "",
      params
    );
    return this.get(url);
  }
}
